import { Card, Typography } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import { UserIcon } from "../../../assets/images";
import { selectUserData } from "../../../config/redux/slices/userSlice/selectors";
import {
  DEFAULT_DISPLAY_FORMAT,
  formatDateToString,
} from "../../../utils/date";
import {
  StyledNameContainer,
  StyledPrimaryDetailsWrapper,
  StyledProfileIcon,
  StyledProfileIconWrapper,
  StyledUserDetailsWrapper,
} from "./styles";

const PrimaryDetails = () => {
  const user = useSelector(selectUserData);
  const { firstName, lastName, email, dateCreated } = user.data;
  return (
    <StyledPrimaryDetailsWrapper>
      <Card>
        <StyledNameContainer>
          <StyledProfileIconWrapper>
            <StyledProfileIcon src={UserIcon} />
          </StyledProfileIconWrapper>
          <StyledUserDetailsWrapper>
            <Typography
              variant="h6"
              color="primary"
            >{`${firstName} ${lastName}`}</Typography>
            <Typography variant="caption" color="textSecondary">
              Email: {email}
            </Typography>
            <Typography variant="caption" color="textSecondary">
              Active since:{" "}
              {formatDateToString(dateCreated, DEFAULT_DISPLAY_FORMAT)}
            </Typography>
          </StyledUserDetailsWrapper>
        </StyledNameContainer>
      </Card>
    </StyledPrimaryDetailsWrapper>
  );
};

export default PrimaryDetails;
